import type { LeadFilters } from '@/features/leads/lead-filters';

/**
 * Clés de cache centralisées.
 *
 * Le module SSE doit viser exactement la même clé que le hook de lecture,
 * sinon `setQueryData` écrit à côté et l'écran ne se met jamais à jour.
 */
export const qk = {
  quota: () => ['quota'] as const,
  countries: () => ['geo', 'countries'] as const,
  regions: (cc: string) => ['geo', 'regions', cc] as const,
  categories: (q: string) => ['categories', q] as const,
  jobs: () => ['jobs'] as const,
  job: (id: string) => ['jobs', id] as const,
  leads: (filters: LeadFilters) => ['leads', filters] as const,
} as const;
